import { motion, useScroll, useSpring } from "framer-motion";

export const ScrollBeam = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 25, mass: 0.4 });
  return (
    <motion.div
      data-testid="scroll-beam"
      aria-hidden="true"
      className="fixed top-0 left-0 right-0 h-[2px] z-[80] origin-left bg-gradient-to-r from-gold via-champagne to-gold shadow-[0_0_14px_rgba(212,175,55,0.85)]"
      style={{ scaleX }}
    />
  );
};
